import $foreign from "./foreign.cjs";
var unfoldrArrayImpl = $foreign.unfoldrArrayImpl;
export { unfoldrArrayImpl };
